//获取浏览器URL参数值
export function getQueryVariable(variable) {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return false
}

/**
 * 将对象添加当作参数拼接到URL上面
 * @param baseUrl 需要拼接的url
 * @param obj 参数对象
 * @returns {string} 拼接后的对象
 * 例子:
 *  let obj = {a: '3', b: '4'}
 *  setObjToUrlParams('www.baidu.com', obj)
 *  ==>www.baidu.com?a=3&b=4
 */
export function setObjToUrlParams(baseUrl, obj) {
  let parameters = ''
  let url = ''
  for (const key in obj) {
    parameters += key + '=' + encodeURIComponent(obj[key]) + '&'
  }
  parameters = parameters.replace(/&$/, '')
  if (/\?$/.test(baseUrl)) {
    url = baseUrl + parameters
  } else {
    url = baseUrl.replace(/\/?$/, '?') + parameters
  }
  return url
}

/**
 * 判断是否 url
 * */
const RegExp = /^http(s)?:\/\//iu
export function isUrl(url) {
  return RegExp.test(url)
}

//获取url中的key并加码
export const getUrlKeyandEncode = (name) => {
  return encodeURIComponent(
    decodeURIComponent(
      (new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(location.href) || [
        undefined,
        ''
      ])[1].replace(/\+/g, '%20')
    ) || null
  )
}

//获取url中加码的key，并解码
export const getDecodeUrlKey = (name) => {
  return (
    decodeURIComponent(
      (new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(location.href) || [
        undefined,
        ''
      ])[1].replace(/\+/g, '%20')
    ) || null
  )
}
